import "./ConfirmPlani.scss";
import { useNavigate } from "react-router-dom";
import PrivatePagesWrapper from "components/PrivatePagesWrapper/PrivatePagesWrapper";
import {
  StartTraveling,
} from "../../../libs/raas-ui-react-components/src/components";
import { CofirmPlaniLiterals } from "./ConfirmPlani.utils";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import useSession from "hooks/useSession";
import {
  setIdTmbSelect,
} from "services/user/user.session.service";
import useToast from "hooks/useToast";
import { ICardTmbActivities } from "pages/public/Planner/PlannerFlow.model";

declare const window: any;
export default function ConfirmPlani() {
  const [t, i18n] = useTranslation("confirmPlani");
  const [tTmb] = useTranslation("tmbPages");
  const navigate = useNavigate();



  const [localidad, setLocalidad] = useState(null);
  const literalsTmb = {titleBanner: tTmb("tmbPlanner.titleBanner"),tripDescription: tTmb("tmbPlanner.tripDescription"),seeMore: tTmb("tmbPlanner.seeMore"),};
  const [activitiesList, setActivitiesList] = useState<ICardTmbActivities>();

  let lenguage = "";


  /**
   * User efect para obtener el token de globick
   */
  useEffect(() => {
    window.dataLayer?.push({
      event: "page_view",
      screen_name: "purchase_confirm",
      screen_class: "trip_confirm",
    });
   if(localidad!=="Barcelona"){
      window.dataLayer?.push({
        event: "page_view",
        screen_name: 'purchase_confirm',
        screen_class: 'trip_confirm',
        //content_name: 'social_login',
        option_selected: 'no_globick',
      });
    }

  }, []);



  useEffect(() => {
    if (sessionStorage.getItem("raas-language") != lenguage) {
      lenguage = sessionStorage.getItem("raas-language") as any;
    }
  }, [t]);




      //Funcion que recoge la activida seleccionada
      const goSeeMoreTmb = (e: any) => {
        if(e.detail){
            //Variable de session para saber que imagen hay que cargar en el detalle
            window.sessionStorage.setItem('raas-id-tmb-image-select', e.detail.image);
            setIdTmbSelect(e.detail.id);
            navigate("/detail-activy");
        }
    }

  return (
    <>
      <div className="confirm-container">
         <StartTraveling
          onButtonEventClick={(ev: CustomEvent) => navigate(ev?.detail)}
          literals={CofirmPlaniLiterals(t)}
          literalsTmb={literalsTmb}
          activitiesList={activitiesList}
          onNavigateSeeMore={goSeeMoreTmb}
        ></StartTraveling> 
      </div>
      <PrivatePagesWrapper></PrivatePagesWrapper>
    </>
  );
}
